<template>
  <div class="d-flex flex-column gap-3 dashboard">
    <div>
      <p class="text-body-secondary mb-0">{{ todayLabel }}</p>
      <h1 class="mb-0">Hallo {{ firstName }}</h1>
    </div>

    <div class="row g-4">
      <div class="col-12 col-xl-12">
        <EventsDashboard />
      </div>
      <div class="col-12 col-xl-12">
        <MembersDashboard />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import EventsDashboard from "@/components/dashboard/EventsDashboard.vue";
import MembersDashboard from "@/components/dashboard/MembersDashboard.vue";
import { AuthenticationContext } from "@/auth/msal-context";

defineOptions({ name: "SSUDashboard" });

const firstName = computed(() => (AuthenticationContext.getActiveAccount()?.name ?? "").split(" ")[0] || "");
const todayLabel = new Date().toLocaleDateString("de-DE", { weekday: "long", day: "numeric", month: "long" });
</script>
